import React from 'react';

const ButtonSpinner = () => {
  return (
    <div className="lds-ellipsis">
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};

export default ButtonSpinner;
